<template>
  <div>
    <v-card class="transparent elevation-0">
            <div style="background-color: #00a7d3">{{info}}</div>
      <v-container container--fluid grid-list-md>
        <v-row>
          <v-col cols="12" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
            <h1>Clients WiFi</h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" md="2">
            <v-row align="center">
              <v-col cols="12" md="6" class="text-center">
                <v-tooltip top color="secondary">
                  <template v-slot:activator="{ on }">
                    <v-btn class="mx-2" fab dark color="blue lighten-1" @click="newNetwork" v-on="on">
                      <v-icon dark>add</v-icon>
                    </v-btn>
                  </template>
                  <span>Create a new</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="renderedNetwork"
        :search="search"
      >
        <template v-slot:item="props">
          <tr class="cursor" v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
            <td style="text-align: center"
                v-for="(header, index) in headers"
                v-if="header.text !== 'Actions'"
                :key="index"
            >{{props.item[header.value]}}</td>
            <td v-else-if="admin || editPermission" style="text-align: center">
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-icon  color="blue" @click="rowSelected(props.item) " v-on="on">
                    edit
                  </v-icon>
                </template>
                <span>Edit</span>
              </v-tooltip>
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-icon color="red" @click="toggleDeleteDialog(props.item)" v-on="on" class="pl-1">
                    delete
                  </v-icon>
                </template>
                <span>Delete</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog
      v-model="deleteDialog"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title>
          <h3>ATTENTION</h3>
        </v-card-title>
        <v-card-text>
          You are about to delete this client device. This action cannot be undone. <br>
          Are you sure you want to proceed ?
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="blue-grey lighten-2" @click="toBeDeleted=null; deleteDialog=false">No</v-btn>
          <v-btn text color="blue darken-1" @click="deleteNetwork">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editDialog" v-if="displayedItem" width="800px">
      <v-card>
        <v-card-title class="d-flex" style="position: relative" :class="$vuetify.breakpoint.smAndDown ? 'justify-start' : 'justify-center'">
          <h2>{{editedIndex > -1 ? 'Edit network' : 'New network'}}</h2>
          <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="editDialog=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row justify="space-around">
            <v-list two-line>
              <v-row justify="center" align="center">
                <v-col cols="12" sm="12" md="6" class="py-0" v-for="(key, index) in Object.keys(displayedItem)" :key="index">
                  <v-list-item >
                    <v-list-item-action>
                      <div>
                        <v-icon>{{icons[key]}}</v-icon>
                      </div>
                    </v-list-item-action>
                    <v-list-item-content class="pt-0">
                      <div >
                        <v-form ref="form" v-model="valid" lazy-validation>
                          <div v-if="key === 'corp' && admin">
                            <v-select
                              :items="corps"
                              v-model="editedItem[key]"></v-select>
                          </div>
                          <div v-else>
                            <v-text-field v-model="editedItem[key]"
                                          :label="capitalizeFirstLetter(key)"
                                          :disabled="readOnly.includes(key)"
                            ></v-text-field>
                          </div>
                        </v-form>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-list>
          </v-row>
          <v-row justify="center" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
            <v-col md="2" cols="12" class="text-center">
              <v-btn
                text
                @click="editDialog=false;"
                color="blue-grey lighten-2"
              >Cancel
              </v-btn>
            </v-col>
            <v-col md="2" cols="12" class="text-center">
              <v-btn
                text
                @click="saveChanges"
                color="blue darken-1"
              >Save
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "WiFiClientController",
  props: {
    isConnected: Boolean,
  },
  data() {
    return {
      reload: false,
      valid: false,
      info:'',
      requiredRule: [
        v => !!v || 'This field is required.'
      ],
      icons: {
        id: 'card_travel',
        name: 'people',
        mac:'wifi',
        corp: 'smartphone',

      },
      readOnly: [
        "id",
      ],
      search: null,
      toBeDeleted: null,
      deleteDialog: false,
      editedIndex: -1,
      editedItem: {
        id: 0,
        name: null,
        mac: null,
        corp: null,
      },
      defaultClient: {
        id: 0,
        name: null,
        mac: null,
        corp: null,
      },
      editDialog: false,
      displayedItem: null,
      region: null,
      headers:[
        {text: 'ID', value: 'id', align: 'center', sortable: true},
        {text: 'Name', value: 'name', align: 'center', sortable: false},
        {text: 'MAC', value: 'mac', align: 'center', sortable: false},
        {text: 'Corp', value: 'corp', align: 'center', sortable: false},
        {text: 'Actions', value: 'actions', align: 'center', sortable: false}
      ],
      corps:[
        true,false
      ],
    }
  },
  methods: {
    newNetwork() {
      this.editedIndex = -1;
      this.displayedItem = Object.assign({}, this.defaultClient);
      this.editedItem = Object.assign({}, this.defaultClient);
      this.fab = false;
      this.editDialog = true;
    },
    capitalizeFirstLetter(string) {
      string = string.replace(/_/g, ' ');
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    rowSelected(item) {
      this.displayedItem = Object.assign({}, item);
      this.editedItem = Object.assign({}, this.displayedItem);
      this.editedIndex = this.wifiClient.indexOf(item);
      this.editDialog = true;
    },
    toggleDeleteDialog(item) {
      this.toBeDeleted = item;
      this.deleteDialog = true;
    },
    deleteNetwork() {
      let index = this.wifiClient.indexOf(this.toBeDeleted);
      axios.delete(process.env.API_URL + '/network/wifi/client/' + this.toBeDeleted.id)
        .then((response) => {
          this.updateDataTable();
          this.deleteDialog = false;
        })
        .catch((response) => {
          this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
        })
    },
    updateDataTable() {
      this.reload = !this.reload;
    },
    validationInput(body){
      if (body.mac !== null) {
        if(!/^[A-Fa-f\d]{2}:[A-Fa-f\d]{2}:[A-Fa-f\d]{2}:[A-Fa-f\d]{2}:[A-Fa-f\d]{2}:[A-Fa-f\d]{2}$/.test(body.mac)){
          this.$store.commit('displaySnackbar', 'Invalidation Mac Address');
          return false;
        } else return true;
      } else {
        this.$store.commit('displaySnackbar', 'Please input IP Address');
        return false;
      }
    },
    saveChanges() {
      let body = this.editedItem;

      if(!this.validationInput(body)){
        return false;
      };

      if (this.editedIndex > -1) {
        axios.put(process.env.API_URL + '/network/wifi/client/' + body.id, body)
          .then((response) => {
            this.updateDataTable();
            this.$store.commit('displaySnackbar', 'Changes saved.');
          })
          .catch((response) => {
            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
          })
      } else {
        axios.post(process.env.API_URL + '/network/wifi', body)
          .then((response) => {
            this.updateDataTable();
            this.$store.commit('displaySnackbar', 'client mac created.');
          })
          .catch((response) => {
            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
          })
      }
      this.editDialog = false;
    }
  },
  computed: {
    admin() {
      return this.$store.getters['auth/isAdmin'];
    },
    editPermission() {
      if (this.region === null) return false;
      if (this.region.id === 0) return this.admin;
      return this.$store.getters['auth/hasPermissionRegionId']('phone_edit', this.region.id);
    },

    renderedNetwork() {
      if (this.wifiClient === null){
        return [];
      } else return this.wifiClient;

    },
  },
  asyncComputed: {
    async wifiClient() {
      if (this.reload || !this.reload) {
        return await axios.get(process.env.API_URL + '/network/wifi')
          .then((response) => {
            return response.data;
          })
          .catch((response) => {
            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
            return [];
          })
      }

    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/WiFiClientController.vue